import { type FC } from "react";

import { ChartSkeletonContainer } from "../../lens-insights/components";
import { PieChartComponent } from "../../lens-insights/components/charts";
import { ChartCard, StatsEmptyStateContainer } from "../../lens-insights/components/shared";
import { type OsStatsItem } from "../../lens-insights/models";

import { flexOneThird, osBreakdown } from "./shared";

interface OSBreakdownProps {
    loading?: boolean;
    stats: OsStatsItem[];
}

// height provided in design
const CHART_HEIGHT = 232;

export const OSBreakdown: FC<OSBreakdownProps> = ({ loading = false, stats }) => (
    <ChartCard title="OS Breakdown" className={`${osBreakdown} ${flexOneThird}`}>
        <StatsEmptyStateContainer isEmpty={loading}>
            <ChartSkeletonContainer height={CHART_HEIGHT} skeletonActive={loading}>
                <PieChartComponent metrics={stats} loading={loading} />
            </ChartSkeletonContainer>
        </StatsEmptyStateContainer>
    </ChartCard>
);
